export default __webpack_public_path__ + "static/media/Illustration - Lined - Sad.9507cd96.svg";